var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bg-gray-300"},[_c('div',{staticClass:"hero-container bg-cover bg-center",style:({ 'background-image': ("url(" + _vm.heroImg + ")") })})])}
var staticRenderFns = []

export { render, staticRenderFns }